import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Warning'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'

const useStyles = makeStyles(theme => ({
  flex: {
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: theme.spacing(2),
    width: 20,
    height: 20
  },
  iconSucess: {
    marginRight: theme.spacing(2),
    width: 20,
    height: 20,
    color: theme.palette.success.dark
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}))

const StatusLabel = props => {
  const { state, message } = props
  const tooltipMessage = props.tooltipMessage
    ? props.tooltipMessage
    : 'Divergência com Dados Externos (Direct Intelligence)'

  const classes = useStyles()
  switch (state) {
    case 'success':
      return (
        <div className={classes.flex}>
          <CheckCircleIcon className={classes.iconSucess} color="inherit" />
          <Typography variant="body1">{message}</Typography>
        </div>
      )
    case 'fetching':
      return (
        <div className={classes.flex}>
          <CircularProgress className={classes.icon} />
          <Typography variant="body1">{message}</Typography>
        </div>
      )
    case 'error':
      return (
        <div className={classes.flex}>
          <Tooltip placement="top" title={tooltipMessage}>
            <WarningIcon className={classes.icon} color="secondary" />
          </Tooltip>
          <Typography variant="body1" color="error">
            {message}
          </Typography>
        </div>
      )
    default:
      return null
  }
}

export default StatusLabel
